import React, { useState, useEffect, useCallback } from 'react';
import './Hero.css';

// Hurricane Melissa landfall: Tuesday, October 28, 2025 at 12:00 PM
const LANDFALL_DATE = new Date('2025-10-28T12:00:00');

const Hero = () => {
  const [timeElapsed, setTimeElapsed] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const calculateTimeElapsed = useCallback(() => {
    const now = new Date();
    const timeDifference = now - LANDFALL_DATE;
    
    // Ensure we don't show negative time
    if (timeDifference < 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    return {
      days: days,
      hours: hours % 24,
      minutes: minutes % 60,
      seconds: seconds % 60
    };
  }, []);

  useEffect(() => {
    const updateTime = () => {
      setTimeElapsed(calculateTimeElapsed());
    };

    // Update immediately
    updateTime();

    // Update every second for real-time counter
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, [calculateTimeElapsed]);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToMap = (mapId) => {
    const element = document.getElementById(mapId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content-wrapper">
          {/* Left side - Text content */}
          <div className="hero-text">
            <div className="hero-badge">
              <span className="badge-live">● LIVE</span>
              <span>AI-Powered Hurricane Recovery</span>
            </div>
            <h1 className="hero-title">
              AI<br/>
              <span className="gradient-text">Humanity</span>
            </h1>
            <p className="hero-subtitle">
              Accelerating Jamaica's recovery from Hurricane Melissa with artificial intelligence. 
              From damage assessment in hours to aid in days, not weeks.
            </p>
            
            {/* Live Stats */}
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-number">TBD</div>
                <div className="stat-label">Aid Distributed</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">TBD</div>
                <div className="stat-label">Families Helped</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">
                  {timeElapsed.days}d {timeElapsed.hours}h {timeElapsed.minutes}m {timeElapsed.seconds}s
                </div>
                <div className="stat-label">Since Landfall</div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="hero-buttons">
              <a href="#climate-data" className="btn btn-secondary" onClick={(e) => scrollToSection(e, 'climate-data')}>
                Climate Dashboard
              </a>
              <button className="btn btn-primary" onClick={() => scrollToMap('damage-map')}>
                🌀 View Damage Map
              </button>
              <button className="btn btn-outline" onClick={() => scrollToMap('recovery-map')}>
                🏥 View Recovery Map
              </button>
              <button className="btn btn-outline orange" onClick={() => scrollToMap('whatif-map')}>
                🎯 What If Scenario
              </button>
            </div>

            {/* Leadership */}
            <div className="leadership-badge">
              <div className="leader-info">
                <span className="leader-label">Led by</span>
                <span className="leader-name">Raymond Pryce</span>
                <span className="leader-role">Chief Operations Officer, ENVIROTEK Group</span>
              </div>
            </div>
          </div>


        </div>
      </div>
    </section>
  );
};

export default Hero;
